import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";

export const TrackingLayout = ({ title, icon: Icon, children, onBack, testId }) => {
  const { t } = useTranslation();
  return <div className="min-h-screen bg-background" data-testid={`${testId}-page`}>
    <div className="border-b border-border bg-card/50 sticky top-0 z-10">
      <div className="max-w-2xl mx-auto px-4 py-4 flex items-center gap-3">
        {onBack ? <button onClick={onBack} aria-label={t("common.back")} data-testid={`${testId}-back`}><ArrowLeft className="w-5 h-5 text-muted-foreground" /></button>
          : <Link to="/" aria-label={t("common.back")} data-testid={`${testId}-back`}><ArrowLeft className="w-5 h-5 text-muted-foreground" /></Link>}
        <Icon className="w-5 h-5 text-primary shrink-0" />
        <h1 className="font-bold text-foreground min-w-0 break-words" data-testid={`${testId}-title`}>{title}</h1>
      </div>
    </div>
    <div className="max-w-2xl mx-auto px-4 py-6 space-y-5">{children}</div>
  </div>;
};

export const RequestError = ({ error, testId }) => error ?
  <p role="alert" data-testid={testId} className="bg-red-900/20 border border-red-700/40 rounded-xl p-4 text-red-300 text-sm break-words">{error}</p> : null;